export default [
	{
		path: "/admin/leads",
		exact: true,
		policy: "supportAdminAuth",
		component: "AdminLeads",
		mui: true,
	},
];
